import React, { useState } from 'react';
import Flatpickr from 'react-flatpickr';
import dayjs from 'dayjs';
import { MdSearch } from 'react-icons/md';
import './CalendarFetch.scss';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { ButtonComponent } from '../../../ReusableComponents/Button/ButtonComponent';
export const CalendarFetchOnlyDates = ({
  fetchValues,
  givenStartDate = dayjs(new Date()),
  givenEndDate = dayjs(new Date()),
}): JSX.Element => {
  const [startDate, setStartDate] = useState(givenStartDate);
  const [endDate, setEndDate] = useState(givenEndDate);

  const changeDay = (date, changeInt) => {
    const newDate = dayjs(date).add(changeInt, 'day');
    return newDate;
  };

  const setCalendarDay = date => {
    const newDate = dayjs(date);
    return newDate;
  };

  const callSearchFunction = e => {
    e.preventDefault();
    fetchValues({ startDate, endDate });
  };

  return (
    <div className="calendarfetch">
      <div className="calendarfetch__datofield">
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          <div className="calendarFetch__datofield__text">From</div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <FaChevronLeft
              onClick={() => setStartDate(changeDay(startDate, -1))}
            />
            <Flatpickr
              onChange={selectedDates =>
                setStartDate(setCalendarDay(selectedDates[0]))
              }
              value={dayjs(startDate).format('DD. MMM YY')}
              options={{
                dateFormat: 'd. M y',
                shorthandCurrentMonth: true,
                locale: { firstDayOfWeek: 1 },
              }}
              render={(props, ref) => (
                <input className={'form-control'} type="text" ref={ref} />
              )}
            />
            <FaChevronRight
              onClick={() => setStartDate(changeDay(startDate, 1))}
            />
          </div>
          <div className="calendarFetch__datofield__text">To</div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <FaChevronLeft onClick={() => setEndDate(changeDay(endDate, -1))} />
            <Flatpickr
              onChange={selectedDates =>
                setEndDate(setCalendarDay(selectedDates[0]))
              }
              value={dayjs(endDate).format('DD. MMM YY')}
              options={{
                dateFormat: 'd. M y',
                shorthandCurrentMonth: true,
                locale: { firstDayOfWeek: 1 },
              }}
              render={(props, ref) => (
                <input className={'form-control'} type="text" ref={ref} />
              )}
            />
            <FaChevronRight onClick={() => setEndDate(changeDay(endDate, 1))} />
          </div>
        </div>
      </div>
      <ButtonComponent
        onClick={callSearchFunction}
        className="calendarfetch__searchbutton"
        variant="outlined"
        startIcon={<MdSearch />}
      >
        Fetch report data
      </ButtonComponent>
    </div>
  );
};
